import {
    IPropertyDetailsEditorModalStyleProps,
    IPropertyDetailsEditorModalStyles
} from './PropertyDetailsEditorModal.types';

export const getStyles = (
    _props: IPropertyDetailsEditorModalStyleProps
): IPropertyDetailsEditorModalStyles => {
    return {
        subComponentStyles: {}
    };
};
